"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHookForm = require("react-hook-form");

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _PermIdentity = _interopRequireDefault(require("@material-ui/icons/PermIdentity"));

var _TextField = _interopRequireDefault(require("@jobmatchme/ui/es/components/TextField"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var GenderAndName = function GenderAndName(_ref) {
  var _ref$gender = _ref.gender,
      gender = _ref$gender === void 0 ? 'mr' : _ref$gender,
      _ref$defaultValueName = _ref.defaultValueName,
      defaultValueName = _ref$defaultValueName === void 0 ? '' : _ref$defaultValueName,
      _ref$translateNs = _ref.translateNs,
      translateNs = _ref$translateNs === void 0 ? 'ui' : _ref$translateNs,
      t = _ref.t;

  var _useFormContext = (0, _reactHookForm.useFormContext)(),
      register = _useFormContext.register,
      control = _useFormContext.control;

  var borderColor = 'DEE0ED';
  var componentNs = "".concat(translateNs, ":ui.Form.GenderAndName");
  var CustomizedSelect = (0, _withStyles.default)(function (theme) {
    return {
      root: {
        'label + &': {
          marginTop: theme.spacing(3)
        }
      },
      input: {
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #".concat(borderColor),
        borderRight: 'none !important',
        borderRadius: 10,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        fontSize: 16,
        padding: '16px 16px 16px 50px',
        marginBottom: '20px',
        width: '100%',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        fontFamily: [_styleModule.default.fontFamilyBase, '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
        '&:focus': {
          borderColor: '#584F75',
          boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
        }
      }
    };
  })(_InputBase.default);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _styleModule.default.genderSelector,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      className: _styleModule.default.grid,
      spacing: 0,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
        item: true,
        xs: 4,
        className: _styleModule.default.selectGrid,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PermIdentity.default, {
          className: _styleModule.default.selectPersonIcon
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
          name: "gender",
          render: function render(_ref2) {
            var _ref2$field = _ref2.field,
                _onChange = _ref2$field.onChange,
                value = _ref2$field.value,
                ref = _ref2$field.ref;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Select.default, {
              input: /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomizedSelect, {}),
              className: _styleModule.default.selectbox,
              displayEmpty: true,
              inputRef: ref,
              onChange: function onChange(e) {
                _onChange(e.target.value);
              },
              value: value || gender,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
                className: _styleModule.default.item,
                button: false,
                value: "mr",
                children: t("".concat(componentNs, ".select.gender.mr"))
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
                className: _styleModule.default.item,
                button: false,
                value: "mrs",
                children: t("".concat(componentNs, ".select.gender.mrs"))
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
                className: _styleModule.default.item,
                button: false,
                value: "diverse",
                children: t("".concat(componentNs, ".select.gender.diverse"))
              })]
            });
          },
          control: control,
          defaultValue: gender
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 8,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
          className: _styleModule.default.nameField,
          type: "text",
          name: "name",
          placeholder: t("".concat(componentNs, ".placeholders.name")),
          bsSize: "lg",
          fullWidth: true,
          inputProps: register('name', {
            required: true
          }),
          defaultInput: true,
          customSize: "medium",
          combinedLeft: true,
          defaultValue: defaultValueName
        })
      })]
    })
  });
};

var _default = GenderAndName;
exports.default = _default;